<template>
  <div class="zzl-visual-editor">
    <ReportEditor :value="sectionsOnlyJson" @input="onSectionsInput" />
  </div>
</template>

<script>
import ReportEditor from './editor.vue';
import {
  normalizeReportDataObject,
  stringifyReportData,
} from './report-edit-payload.js';

/**
 * 仅编辑 API 字段 data（sections）；emit 为 data 的 JSON 字符串，不含 static_data。
 */
export default {
  name: 'ZzlReportVisualEditor',
  components: {ReportEditor},
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      root: normalizeReportDataObject({}),
      syncingFromProp: false,
      emitTimer: null,
    };
  },
  computed: {
    sectionsOnlyJson() {
      const segs = this.root.sections;
      const sections = Array.isArray(segs) ? segs : [];
      return JSON.stringify({sections});
    },
  },
  watch: {
    value: {
      handler(s) {
        this.syncingFromProp = true;
        this.hydrate(s);
        this.$nextTick(() => {
          this.syncingFromProp = false;
        });
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.emitTimer) {
      clearTimeout(this.emitTimer);
    }
  },
  methods: {
    hydrate(s) {
      let o = {};
      try {
        o = s && String(s).trim() ? JSON.parse(s) : {};
      } catch (e) {
        o = {};
      }
      this.root = normalizeReportDataObject(o);
    },
    scheduleEmit() {
      if (this.syncingFromProp || this.disabled) {
        return;
      }
      if (this.emitTimer) {
        clearTimeout(this.emitTimer);
      }
      this.emitTimer = setTimeout(() => this.emitFull(), 300);
    },
    onSectionsInput(jsonStr) {
      if (this.syncingFromProp || this.disabled) {
        return;
      }
      try {
        const inner = JSON.parse(jsonStr || '{"sections":[]}');
        const next = Array.isArray(inner.sections) ? inner.sections : [];
        this.$set(this.root, 'sections', next);
      } catch (e) {
        this.$set(this.root, 'sections', []);
      }
      this.scheduleEmit();
    },
    emitFull() {
      if (this.syncingFromProp) {
        return;
      }
      try {
        const out = stringifyReportData(this.root);
        this.$emit('input', out);
      } catch (e) {
        console.error('ZzlReportVisualEditor emit', e);
      }
    },
  },
};
</script>

<style scoped lang="less">
.zzl-visual-editor {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
}
</style>
